import classNames from 'clsx';
import React from 'react';
import { useLocation } from 'react-router';
import useDarkMode from 'use-dark-mode';

import StarsNavigation, { Variant } from '@swf/components/StarsNavigation/StarsNavigation';
import StarsNavigationItem from '@swf/components/StarsNavigation/StarsNavigationItem';
import Translation from '@swf/components/Translation/Translation';
import type { NavLink } from '@swf/core/types/Poker';

import styles from './MainNav.scss';

interface NavItem extends NavLink {
  active?: boolean;
}

export interface Props {
  active?: boolean;
  links?: NavItem[];
  className?: string;
  innerClassName?: string;
  navItemClassName?: string;
}

const MainNav = ({ links, className, innerClassName, navItemClassName }: Props) => {
  const { value: isDarkMode } = useDarkMode();
  const { pathname } = useLocation();

  if (!links || !links.length) return null;

  return (
    <StarsNavigation
      className={classNames(styles.container, className)}
      innerClassName={classNames(styles.innerContainer, innerClassName)}
      variant={isDarkMode ? Variant.Dark : Variant.Light}
    >
      {links.map(({ active, translation, href }) => (
        <StarsNavigationItem
          className={classNames(styles.navItem, navItemClassName)}
          href={href}
          key={href}
          isActive={() => active ?? pathname.includes(href)}
        >
          <Translation {...translation} />
        </StarsNavigationItem>
      ))}
    </StarsNavigation>
  );
};

export default MainNav;
